import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import moment from "moment";

import RichTextBlock from "./RichTextBlock";
import ShareButtons from "./ShareButtons";
import BlogPostTopicsLinks from "./BlogPostTopicsLinks";
import BlogPostNavigation from "./BlogPostNavigation";
import GatsbyImageWithSVGSupport from "./GatsbyImageWithSVGSupport";

const BlogPost = ({ blogPost, pageContext }) => (
    <article className="blog-post">
        <h1 className="title">{blogPost.title}</h1>

        <div className="authorship">
            {blogPost.author?.name && (
                <>
                    By <strong>{blogPost.author.name}</strong>
                </>
            )}
            <span className="divider">/</span>
            <time
                itemProp="datePublished"
                content={moment(blogPost.publishDate).format(
                    "YYYY-MM-DDThh:mm:ss.sTZD",
                )}
                dateTime={moment(blogPost.publishDate).format("MMMM D, YYYY")}
            >
                {moment(blogPost.publishDate).format("MMMM D, YYYY")}
            </time>
            <span className="divider">/</span>
            <BlogPostTopicsLinks
                topics={blogPost.topics}
                urlPrefix={pageContext.blogPrefix}
            />
        </div>

        <ShareButtons />

        {blogPost.image && !blogPost.hideImageOnFullPage && (
            <GatsbyImageWithSVGSupport
                image={blogPost.image}
                className="image"
            />
        )}

        <div
            className={classNames("body", {
                "fade-text": blogPost.fadeBodyText,
            })}
        >
            <RichTextBlock content={blogPost.body} />
        </div>

        <ShareButtons />

        <BlogPostNavigation
            previous={pageContext.previousBlogPost}
            next={pageContext.nextBlogPost}
            blogPrefix={pageContext.blogPrefix}
        />
    </article>
);

BlogPost.propTypes = {
    blogPost: PropTypes.shape({
        title: PropTypes.string.isRequired,
        publishDate: PropTypes.string.isRequired,
        hideImageOnFullPage: PropTypes.bool,
        image: PropTypes.shape({ gatsbyImageData: PropTypes.object })
            .isRequired,
        body: PropTypes.shape({ raw: PropTypes.string.isRequired }).isRequired,
        fadeBodyText: PropTypes.bool,
        author: PropTypes.shape({ name: PropTypes.string.isRequired }),
        topics: PropTypes.arrayOf(
            PropTypes.shape({
                slug: PropTypes.string.isRequired,
                name: PropTypes.string.isRequired,
            }),
        ),
    }),
    recentBlogPosts: PropTypes.arrayOf(
        PropTypes.shape({
            title: PropTypes.string.isRequired,
            publishDate: PropTypes.string.isRequired,
            image: PropTypes.shape({ gatsbyImageData: PropTypes.object })
                .isRequired,
        }),
    ),
    pageContext: PropTypes.shape({
        previous: PropTypes.shape({
            slug: PropTypes.string.isRequired,
            title: PropTypes.string.isRequired,
        }),
        next: PropTypes.shape({
            slug: PropTypes.string.isRequired,
            title: PropTypes.string.isRequired,
        }),
    }),
};

export default BlogPost;
